module.exports = (Promise.resolve(__parcel__require__("./" + "Doppio.bbc51261.07959d60.js"))).then(() => parcelRequire('dp4mC'));